import Bowser from 'bowser';
const browser = Bowser.getParser( window.navigator.userAgent );
const { viewport } = require( 'etc/viewport.js' );
const {
  small: mobile,
  large: large,
} = viewport;
const [ , mobile_width ] = mobile;
const [ , large_width ] = large;

export const isMobile = () => {
  const document_width = document.documentElement.clientWidth;
  return ( document_width <= mobile_width ) ? true : false;
};

export const isLarge = () => {
  const document_width = document.documentElement.clientWidth;
  return ( document_width > large_width ) ? true : false;
};

export const isGecko = () => {
  const engine = browser.getEngineName();
  return ( engine === 'Gecko' ) ? true : false;
}
